import { Children, FC, ReactNode } from 'react'
import classnames from 'classnames'

import Layout from '../../Layout'

import styles from './TwoColumnLayout.module.scss'

type ContentProps = {
  children: ReactNode[]
  withoutFooter?: boolean
}

const TwoColumnLayout: FC<ContentProps> = ({ children, withoutFooter }) => (
  <div className={classnames(styles.wrapper)}>
    <Layout.Header />
    <div className={classnames(styles['content-wrapper'])}>
      <div className={classnames(styles.TwoColumnLayout)}>
        {Children.map(children, (child) => child)}
      </div>
    </div>
    {!withoutFooter && <Layout.Footer />}
  </div>
)

export default TwoColumnLayout
